export default {"src":"/_next/static/media/placeBid.8a0ed15e.svg","height":21,"width":22};